// Authentication configuration
export const AUTH_CONFIG = {
    // Main portal password
    password: 'crypto@8765',
    
    // Trading tools password (second level authentication)
    tradingPassword: 'trading2025secure',
    
    // Future OAuth/SSO integrations
    oauth: {
      google: {
        enabled: false,
        clientId: 'YOUR_GOOGLE_CLIENT_ID'
      },
      github: {
        enabled: false,
        clientId: 'YOUR_GITHUB_CLIENT_ID'
      }
    },
    
    // Main session settings
    session: {
      // How long the session lasts (in hours)
      duration: 24,
      // Storage key
      storageKey: 'mangumstreet-auth-v2'
    },
    
    // Trading session settings
    tradingSession: {
      // How long the trading session lasts (in hours)
      duration: 4,
      // Storage keys
      storageKey: 'mangumstreet-trading-auth',
      expirationKey: 'mangumstreet-trading-expiration'
    }
  };
  
  // App URLs configuration
  export const APP_URLS = {
    warRoom: {
      main: 'https://warroom.mangumstreet.com',
      dashboard: 'https://dashboard.mangumstreet.com',
      analytics: 'https://analytics.mangumstreet.com',
      news: 'https://news.mangumstreet.com',
      micro: 'https://micro.mangumstreet.com',
      market: 'https://market.mangumstreet.com',
      position: 'https://position.mangumstreet.com'
    },
    tools: {
      cyclePublic: 'https://cycle.mangumstreet.com',
      apSync: 'https://ap-sync.mangumstreet.com',
      strategyTracker: 'https://strategy-tracker.mangumstreet.com',
      trading: 'https://trading.mangumstreet.com',
      cascadeEngine: 'https://cascade-engine-gaon.onrender.com'
    }
  };